<template>
  <div class="">
    <div class="row">
      <div class="col flow-text"><h5>Formulario para Devoluciones</h5></div>
    </div>
    <div class="row">
      <form @submit="save($event)">
        <div class="col s12 input-field">
          <label class="active" for="event_status">Estatus del cartón</label>
          <select class="browser-default" id="event_status" v-model="event_status" required>
            <option value="mas-de-30-dias-en-almacen">Más de 30 días en almacén</option>
            <option value="material-dañado">Repetición</option>
            <option value="material-extraviado">Material extraviado</option>
            <option value="cambio-de-via">Cambio de vía de envío/sucursal</option>
            <option value="otros">Otros</option>
          </select>

        </div>
        <div class="input-field col s12">
          <label for="">Más detalles sobre la devolución</label>
          <textarea
            required
            v-model="motivo_devolucion"
            class="materialize-textarea"
            name=""
            id="motivo_devolucion"
            cols="30"
            rows="10"
          >
          </textarea>
        </div>

        <!--  Action button  -->
        <div class="fixed-action-btn">
          <button
            v-if="!cargando"
            type="submit"
            class="btn-floating btn-large blue"
          >
            <i class="large material-icons">save</i>
          </button>
          <div v-else class="preloader-wrapper active">
            <div class="spinner-layer spinner-red-only">
              <div class="circle-clipper left">
                <div class="circle"></div>
              </div>
              <div class="gap-patch">
                <div class="circle"></div>
              </div>
              <div class="circle-clipper right">
                <div class="circle"></div>
              </div>
            </div>
          </div>
        </div>
        <!--  /Action button  -->
      </form>
    </div>
  </div>
</template>
<script>
import {updateCartons} from "@/tracker/firebase_models/updateCartons"
import M from "materialize-css";
//import firebase from "firebase/app";
import {EVENT_CARTON_DEVUELTO} from "@/constants";
import Helpers from "@/helpers";
export default {
  props: {
    db: Object,
    shipvia: Object,
    almacen: Object,
    shipvias: Array,
    cartons: Object,
  },
  components: {},
  created() {},
  data() {
    return {
      cargando: false,
      motivo_devolucion: undefined,
      event_status:null,
    };
  },
  computed: {
    evento() {
      let desc = `Material regresado por ${window.user.displayName} en la sucursal ${this.almacen.iclocdesc}. Debido a: ${this.motivo_devolucion}`;
      return Helpers.createCartonEvent(
        this.event_status,
        desc,
        window.user.email
      );
    },
  },
  methods: {
    async save(e) {
      e.preventDefault();
      if (!this.almacen)
        return M.toast({
          html: "No has seleccionado un almacen",
          classes: "orange",
        });

      let user = window.user,
        batch = {}, // Definimos un lote de registros
        //shipvia = this.shipvia,
        almacen = this.almacen,
        cartons = this.cartons,
        cartons_keys = Object.keys(cartons);
      if (!cartons_keys.length) {
        M.toast({ html: "No hay paquetes que procesar.", classes: "red" });
        return;
      }

      cartons_keys.forEach((cartonId) => {
        // Por cada carton
        let carton_data = cartons[cartonId];
          // DEPRECATED: docRef = Carton.docRef(cartonId, this.db); // Referencia a un documento
        // Agrega información al documento
        
        carton_data.status = this.evento.status;
        carton_data.status_desc = this.evento.desc;
        carton_data.status_code = EVENT_CARTON_DEVUELTO;

        // Agrega evento
        let event_data = {...this.evento, status_code: carton_data.status_code}
        carton_data["ARRAY_UNION.eventos"]=event_data;

        carton_data.location = almacen.iclocdesc;
        carton_data.devuelto = "SERVER_TIMESTAMP";
        // informacion sobre usuario
        carton_data.last_user_email = user.email;
        // timestamps
        carton_data.updated_at = "SERVER_TIMESTAMP";
        carton_data.updated = (new Date()).toLocaleString();
        // Sino existe el documento se crea con la información, si existe se actualiza.
        //DEPRECATED: batch.set(docRef, carton_data, { merge: true });
        // SET TO BATCH COLLECTION
        batch[cartonId] = carton_data;
         //resplado en base de datos mongo
        //Carton.backupDoc({ _id: cartonId, ...carton_data });

      });
      this.cargando = true;
      updateCartons(batch, await window.user.getIdToken())
      .then(() => {
         //despachar evento para limpiar tablas
          document.dispatchEvent(new Event("limpiarEscaneos"));
          this.motivo_devolucion = undefined;
          //Todo correcto
          M.toast({ html: "Guardado exitosamente", classes: "green" });
      })
        .catch((err) => {
        M.toast({ html: "Error: " + err, classes: "red" });
      })
      .finally(() => {
        this.cargando = false;
      });
    },
  },
};
</script>